import mixpanel from 'mixpanel-browser'
import { config } from '../config'

export const mixpanelTrack = (eventName: string, options = {}) => {
  if (config.mixpanelKey)
    mixpanel.track(eventName, {
      ...options,
      $current_url: window.location.host,
    })
}

export const mixpanelIdentify = (identifier: string) => {
  if (config.mixpanelKey) {
    mixpanel.identify(identifier)
  }
}
